import { Box, Button, Field, Flex, Image, Input, InputGroup, Tabs, VStack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { React, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { usePostFormMutation } from "@/hooks/microservicesApi";
import { emailRegex } from "@/utilities/text/regex";

import PopupCitaGuiaRent from "./popupCitaGuiaRent";

const ContactModal = ({
    tipo,
    id,
    hubspotForm,
    nameDev,
    numeroAsesor,
    numeroWhatsApp,
    idx,
    urlDev,
    setIdx,
    city,
    nameAsesor,
}) => {
    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [telefonoError, setTelefonoError] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [nombreError, setNombreError] = useState(false);
    const [apellidoError, setApellidoError] = useState(false);
    const router = useRouter();
    const [postForm] = usePostFormMutation();

    const currentDate = () => {
        const today = new Date(new Date().setHours(24));
        const year = today.getFullYear();
        const month = today.getMonth();
        const day = today.getDate();
        return `${year}-${String(month).length === 1 ? "0" + month : month}-${day}`;
    };

    const [fechaM] = useState(currentDate());
    const [horaM] = useState("10:00");

    const [isRentOpen, setIsRentOpen] = useState(false);
    const onRentClose = () => setIsRentOpen(false);

    const [isCitaOpen, setIsCitaOpen] = useState(false);
    const onCitaClose = () => setIsCitaOpen(false);

    const location = useRouter();
    const esGuiaRent =
        location.pathname.includes("guiarent") || router.query["city-id"].includes("guiarent");
    const guiarentHubspotFormDirecta = "664b54d0-13c5-416a-a56c-9fa8ec4f5bfb";
    const guiarentHubspotFormCita = "80ad70a0-4734-4ce0-b54f-c3011726ad92";

    const handleSubmit = () => {
        let data_send = {};
        if (tipo === "Propiedad") {
            if (esGuiaRent) {
                data_send = {
                    id: hubspotForm,
                    body: {
                        fields: [
                            {
                                name: "firstname",
                                value: nombre,
                            },
                            {
                                name: "lastname",
                                value: apellidos,
                            },
                            {
                                name: "email",
                                value: email,
                            },
                            {
                                name: "phone",
                                value: telefono,
                            },
                            {
                                name: "asesor_opcionador_de_la_renta",
                                value: nameAsesor,
                            },
                        ],
                        context: {
                            ipAddress: "3.14.97.137",
                            pageUri: "www.grupoguia.mx",
                            pageName: "Grupo Guia | " + tipo + " " + id,
                        },
                    },
                };
            } else {
                data_send = {
                    id: hubspotForm,
                    body: {
                        fields: [
                            {
                                name: "firstname",
                                value: nombre,
                            },
                            {
                                name: "lastname",
                                value: apellidos,
                            },
                            {
                                name: "email",
                                value: email,
                            },
                            {
                                name: "phone",
                                value: telefono,
                            },

                            {
                                name: tipo === "Desarrollo" ? "message" : "wiggot",
                                value: urlDev,
                            },
                        ],
                        context: {
                            ipAddress: "3.14.97.137",
                            pageUri: "www.grupoguia.mx",
                            pageName: "Grupo Guia | " + tipo + " " + id,
                        },
                    },
                };
            }
        } else {
            data_send = {
                id: hubspotForm,
                body: {
                    fields: [
                        {
                            name: "firstname",
                            value: nombre,
                        },
                        {
                            name: "lastname",
                            value: apellidos,
                        },
                        {
                            name: "email",
                            value: email,
                        },
                        {
                            name: "phone",
                            value: telefono,
                        },
                        {
                            name: "he_leido_y_acepto_el_aviso_de_privacidad",
                            value: true,
                        },
                    ],
                    context: {
                        ipAddress: "3.14.97.137",
                        pageUri: "www.grupoguia.mx",
                        pageName: "Grupo Guia | " + tipo + " " + id,
                    },
                },
            };
        }

        postForm(data_send)
            .then(() => {
                setNombre("");
                setApellidos("");
                setEmail("");
                setTelefono("");
                router.push("/desarrollos/thankyoupage-agenda-cita");
            })
            .catch((error) => {
                console.error("Error: ", error);
                toast.error(
                    "¡Hubo un error al enviar tu solicitud, por favor intenta nuevamente!",
                    {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    }
                );
            });
    };

    const handleSubmitWhatsapp = () => {
        let data_send = {};
        if (tipo === "Propiedad") {
            if (esGuiaRent) {
                data_send = {
                    id: hubspotForm,
                    body: {
                        fields: [
                            {
                                name: "firstname",
                                value: nombre,
                            },
                            {
                                name: "lastname",
                                value: apellidos,
                            },
                            {
                                name: "email",
                                value: email,
                            },
                            {
                                name: "phone",
                                value: telefono,
                            },

                            {
                                name: tipo === "Desarrollo" ? "message" : "wiggot",
                                value: urlDev,
                            },
                            {
                                name: "asesor_opcionador_de_la_renta",
                                value: nameAsesor,
                            },
                        ],
                        context: {
                            ipAddress: "3.14.97.137",
                            pageUri: "www.grupoguia.mx",
                            pageName: "Grupo Guia | " + tipo + " " + id,
                        },
                    },
                };
            } else {
                data_send = {
                    id: hubspotForm,
                    body: {
                        fields: [
                            {
                                name: "firstname",
                                value: nombre,
                            },
                            {
                                name: "lastname",
                                value: apellidos,
                            },
                            {
                                name: "email",
                                value: email,
                            },
                            {
                                name: "phone",
                                value: telefono,
                            },

                            {
                                name: tipo === "Desarrollo" ? "message" : "wiggot",
                                value: urlDev,
                            },
                        ],
                        context: {
                            ipAddress: "3.14.97.137",
                            pageUri: "www.grupoguia.mx",
                            pageName: "Grupo Guia | " + tipo + " " + id,
                        },
                    },
                };
            }
        } else {
            data_send = {
                id: hubspotForm,
                body: {
                    fields: [
                        {
                            name: "firstname",
                            value: nombre,
                        },
                        {
                            name: "lastname",
                            value: apellidos,
                        },
                        {
                            name: "email",
                            value: email,
                        },
                        {
                            name: "phone",
                            value: telefono,
                        },
                        {
                            name: "he_leido_y_acepto_el_aviso_de_privacidad",
                            value: true,
                        },
                    ],
                    context: {
                        ipAddress: "3.14.97.137",
                        pageUri: "www.grupoguia.mx",
                        pageName: "Grupo Guia | " + tipo + " " + id,
                    },
                },
            };
        }

        postForm(data_send)
            .then(() => {
                window.open(
                    `https://api.whatsapp.com/send?phone=${numeroWhatsApp ? numeroWhatsApp : numeroAsesor}&text=${`Hola mi nombre es ${nombre} ${apellidos}, me gustaría saber mas sobre 
        ${nameDev}`}`
                );
                setNombre("");
                setApellidos("");
                setEmail("");
                setTelefono("");
                router.push(
                    `/desarrollos/thankyoupage-contactar-whatsapp/${numeroWhatsApp ? numeroWhatsApp : numeroAsesor}`
                );
            })
            .catch((error) => {
                console.error("Error: ", error);
            });
    };

    return (
        <>
            <PopupCitaGuiaRent
                fecha={fechaM}
                hora={horaM}
                isRentOpen={isCitaOpen}
                onRentClose={onCitaClose}
                tipo={tipo}
                id={id}
                conCita={true}
                hubspotForm={guiarentHubspotFormCita}
            />
            <PopupCitaGuiaRent
                fecha={fechaM}
                hora={horaM}
                isRentOpen={isRentOpen}
                onRentClose={onRentClose}
                tipo={tipo}
                id={id}
                conCita={false}
                hubspotForm={guiarentHubspotFormDirecta}
            />
            <VStack borderRadius="md" border="1px solid #D9D9D9" bg="white">
                <Tabs.Root
                    fitted
                    variant="unstyled"
                    w="100%"
                    value={idx.toString()}
                    onValueChange={(detail) => {
                        setIdx(parseInt(detail.value));
                    }}
                >
                    <Tabs.List>
                        <Tabs.Trigger
                            value="0"
                            py="8"
                            bg="gray.200"
                            _selected={{ bg: "white", fontWeight: "600" }}
                            display={
                                numeroWhatsApp !== "0000000000" && city !== "retail"
                                    ? "block"
                                    : "none"
                            }
                        >
                            Enviar Whatsapp
                        </Tabs.Trigger>
                        <Tabs.Trigger
                            value="1"
                            py="8"
                            bg="gray.200"
                            _selected={{ bg: "white", fontWeight: "600" }}
                        >
                            Quiero saber más
                        </Tabs.Trigger>
                    </Tabs.List>

                    <Tabs.Content value="0" p={10}>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmitWhatsapp();
                            }}
                        >
                            <Field.Root invalid={nombreError} gap={0} required>
                                <Input
                                    onInvalid={() => {
                                        setNombreError(true);
                                    }}
                                    rounded="full"
                                    placeholder="Nombre/s:"
                                    marginBottom="10px"
                                    id="nombres"
                                    type="text"
                                    value={nombre}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setNombre(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setNombre(e.target.value);
                                        if (e.target.value.trim() != "") {
                                            setNombreError(false);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    px={4}
                                />
                                {nombreError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El nombre es necesario
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={apellidoError} gap={0} required>
                                <Input
                                    onInvalid={() => setApellidoError(true)}
                                    rounded="full"
                                    placeholder="Apellidos:"
                                    marginBottom="10px"
                                    value={apellidos}
                                    id="apellidos"
                                    type="text"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setApellidos(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setApellidos(e.target.value);
                                        if (e.target.value.trim() != "") {
                                            setApellidoError(false);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    px={4}
                                />
                                {apellidoError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El apellido es necesario
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={emailError} gap={0} required>
                                <Input
                                    onInvalid={() => setEmailError(true)}
                                    rounded="full"
                                    placeholder="Correo:"
                                    marginBottom="10px"
                                    value={email}
                                    id="email"
                                    type="email"
                                    autoComplete="email"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setEmail(e.target.value);
                                        if (!emailRegex.test(e.target.value)) {
                                            setEmailError(true);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setEmail(e.target.value);
                                        if (
                                            e.target.value.trim() != "" &&
                                            emailRegex.test(e.target.value)
                                        ) {
                                            setEmailError(false);
                                        } else {
                                            setEmailError(true);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    pattern={emailRegex}
                                    px={4}
                                />
                                {emailError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        La dirección de correo no es válida
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={telefonoError} gap={0} required>
                                <InputGroup
                                    marginBottom="20px"
                                    borderLeftRadius="full"
                                    overflow="hidden"
                                    startAddon={
                                        <Flex
                                            gap={2}
                                            p={2}
                                            w="100%"
                                            h="100%"
                                            bg="#FFF"
                                            align="center"
                                            borderLeftRadius="full"
                                        >
                                            <Box backgroundColor="#FFFFFF" rounded="full">
                                                <Image
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                    width="16px"
                                                    height="16px"
                                                    alt="mexico"
                                                />
                                            </Box>
                                            <Box
                                                backgroundColor="#FFFFFF"
                                                borderLeftColor="#FFFFFF"
                                                borderRadius="0px"
                                                padding="0px"
                                                paddingRight="10px"
                                                color="#000"
                                            >
                                                +52
                                            </Box>
                                        </Flex>
                                    }
                                >
                                    <Input
                                        onInvalid={() => setTelefonoError(true)}
                                        borderRadius="24px"
                                        placeholder="Teléfono:"
                                        type="number"
                                        id="telefono"
                                        value={telefono}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setTelefono(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setTelefono(e.target.value);
                                            if (e.target.value.trim() != "") {
                                                setTelefonoError(false);
                                            }
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            fontSize: "md",
                                        }}
                                        px={4}
                                    />
                                </InputGroup>
                                {telefonoError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El teléfono no es válido
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Button
                                rounded="full"
                                w="100%"
                                fontWeight="500"
                                color="black"
                                borderColor="#FFCD00"
                                bg="#FFCD00"
                                _hover={{
                                    bg: "#EDBE00",
                                }}
                                disabled={
                                    nombreError || apellidoError || telefonoError || emailError
                                }
                                type="submit"
                            >
                                Envía whatsapp
                            </Button>
                            <VStack alignItems="center" mt="4">
                                <Checkbox required size="sm" color="black" colorPalette="blue">
                                    He leído y acepto los Términos y condiciones.
                                </Checkbox>
                            </VStack>
                        </form>
                    </Tabs.Content>
                    <Tabs.Content value="1" p={10}>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                        >
                            <Field.Root invalid={nombreError} gap={0} required>
                                <Input
                                    onInvalid={() => setNombreError(true)}
                                    rounded="full"
                                    placeholder="Nombre/s:"
                                    marginBottom="10px"
                                    id="nombres"
                                    type="text"
                                    value={nombre}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setNombre(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setNombre(e.target.value);
                                        if (e.target.value.trim() != "") {
                                            setNombreError(false);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    px={4}
                                />
                                {nombreError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El nombre es necesario
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={apellidoError} gap={0} required>
                                <Input
                                    onInvalid={() => setApellidoError(true)}
                                    rounded="full"
                                    placeholder="Apellidos:"
                                    marginBottom="10px"
                                    value={apellidos}
                                    id="apellidos"
                                    type="text"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setApellidos(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setApellidos(e.target.value);
                                        if (e.target.value.trim() != "") {
                                            setApellidoError(false);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    px={4}
                                />
                                {apellidoError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El apellido es necesario
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={emailError} gap={0} required>
                                <Input
                                    onInvalid={() => setEmailError(true)}
                                    rounded="full"
                                    placeholder="Correo:"
                                    marginBottom="10px"
                                    value={email}
                                    id="email"
                                    type="email"
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setEmail(e.target.value);
                                        if (!emailRegex.test(e.target.value)) {
                                            setEmailError(true);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setEmail(e.target.value);
                                        if (
                                            e.target.value.trim() != "" &&
                                            emailRegex.test(e.target.value)
                                        ) {
                                            setEmailError(false);
                                        } else {
                                            setEmailError(true);
                                        }
                                    }}
                                    _placeholder={{
                                        color: "#3C3C3C",
                                        fontSize: "md",
                                    }}
                                    px={4}
                                />
                                {emailError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        La dirección de correo no es válida
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Field.Root invalid={telefonoError} gap={0} required>
                                <InputGroup
                                    marginBottom="20px"
                                    borderLeftRadius="full"
                                    overflow="hidden"
                                    startAddon={
                                        <Flex
                                            gap={2}
                                            p={2}
                                            w="100%"
                                            h="100%"
                                            bg="#FFF"
                                            align="center"
                                            borderLeftRadius="full"
                                        >
                                            <Box backgroundColor="#FFFFFF" rounded="full">
                                                <Image
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                    width="16px"
                                                    height="16px"
                                                    alt="mexico"
                                                />
                                            </Box>
                                            <Box
                                                backgroundColor="#FFFFFF"
                                                borderLeftColor="#FFFFFF"
                                                borderRadius="0px"
                                                padding="0px"
                                                paddingRight="10px"
                                                color="#000"
                                            >
                                                +52
                                            </Box>
                                        </Flex>
                                    }
                                >
                                    <Input
                                        onInvalid={() => setTelefonoError(true)}
                                        borderRadius="24px"
                                        placeholder="Teléfono:"
                                        type="number"
                                        id="telefono"
                                        value={telefono}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setTelefono(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setTelefono(e.target.value);
                                            if (e.target.value.trim() != "") {
                                                setTelefonoError(false);
                                            }
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            fontSize: "md",
                                        }}
                                        px={4}
                                    />
                                </InputGroup>
                                {telefonoError && (
                                    <Field.ErrorText ml="4" color="red.500" mb={4}>
                                        El teléfono no es válido
                                    </Field.ErrorText>
                                )}
                            </Field.Root>
                            <Button
                                rounded="full"
                                w="100%"
                                fontWeight="500"
                                color="black"
                                borderColor="#FFCD00"
                                bg="#FFCD00"
                                _hover={{
                                    bg: "#EDBE00",
                                }}
                                type="submit"
                                disabled={
                                    !nombreError && !apellidoError && !telefonoError && !emailError
                                        ? false
                                        : true
                                }
                            >
                                Enviar
                            </Button>
                            <VStack alignItems="center" mt="4">
                                <Checkbox required size="sm">
                                    He leído y acepto los Términos y condiciones.
                                </Checkbox>
                            </VStack>
                        </form>
                    </Tabs.Content>
                </Tabs.Root>
            </VStack>
        </>
    );
};

export default ContactModal;
